/**
 * Refund / Cancellation Policy (#126, FR-13.1). Default stance (issue decision 4):
 * credits are a digital good and are non-refundable once granted, except where required
 * by law, with a support-contact path for disputes. Static, unauthenticated,
 * prerenderable; product name from {@link BRAND_NAME}.
 */

import { LegalPage } from '../ui/legal/LegalPage';
import { BRAND_NAME } from '../ui/brand';

export function RefundsPage(): React.JSX.Element {
  return (
    <LegalPage
      title="Refund & Cancellation Policy"
      testId="legal-refunds"
      path="/refunds"
    >
      <section>
        <h2>1. Credits are a digital good</h2>
        <p>
          {BRAND_NAME} sells <strong>credits</strong>, a prepaid digital good used to
          access paid features. Credits are delivered to your account immediately after
          purchase.
        </p>
      </section>
      <section>
        <h2>2. Non-refundable once granted</h2>
        <p>
          Because credits are delivered instantly and consumed digitally,{' '}
          <strong>purchased credits are non-refundable once granted</strong>, except where
          a refund is required by applicable law. Unused credits are not redeemable for
          cash.
        </p>
      </section>
      <section>
        <h2>3. Cancellation</h2>
        <p>
          Purchases are one-off; there is no recurring subscription to cancel. You may
          stop using the Service at any time. Any credits remaining on your account stay
          subject to this policy.
        </p>
      </section>
      <section>
        <h2>4. Problems and disputes</h2>
        <p>
          If a charge is incorrect, a purchase failed to grant credits, or you believe you
          are entitled to a refund under applicable law, contact us using the address
          below and we will work with you to resolve it.
        </p>
      </section>
    </LegalPage>
  );
}
